//@import dependencies
import React, { useState, useEffect, ChangeEvent } from 'react'
import { useTranslation } from 'react-i18next'
//@end

//@import components
//@end

// @import hooks
// @end

// @INFO Import types
// @end

// @INFO Import services
// @end

// @INFO Import Styles
import './../descriptivetrainingformModule.scss'
import InputComponent from 'app_components/commons/Input/InputComponent';
import InputFileComponent from 'app_components/commons/InputFileComponent/InputFileComponent';
import TinyEditorComponent from 'app_components/commons/tinyEditor';
import TextComponent from 'app_components/commons/TextComponent/TextComponent';
import ButtonComponent from 'app_components/commons/Button/ButtonComponent';
import { IDescriptiveTraining } from 'app_types/admin/landings/landingTypes';

// @ADD Component types
interface IDescriptivetrainingformModuleLayoutProps {
  title?: string
  data?: IDescriptiveTraining
  onHandleDescriptiveTrainingSubmit: (data: any) => void | null
}

interface IFormData{
  title: string
  attachedFile?: any
  content?: any
}

const DescriptivetrainingformModuleLayout: React.FC<IDescriptivetrainingformModuleLayoutProps> = (props) => {

  const [resetTiny, updateResetTiny] = useState<boolean>(false)
  const [formData, updateFormData] = useState<IFormData>({
    title: '',
    attachedFile: undefined,
    content: ''
  })
  const { t } = useTranslation()

  useEffect(() => {
    if(props.data){
      updateFormData({
        title: props.data?.title,
        attachedFile: props.data?.image as any,
        content: props.data?.content ? props.data?.content : ''
      })
      updateResetTiny(true)
      setTimeout(() => {
        updateResetTiny(false)
      },10)
    }
  },[props.data])

  const handleChangeForm = (e: ChangeEvent<HTMLInputElement>) => {
    updateFormData({
      ...formData,
      [e.target.name]: e.target.value
    })
  }

  return(
    <div className='descriptive_training_form-layout'>
      <div className="d-flex align-items-center mb-2">
        <h3 className="form-title">{props.title || 'Formación descriptiva'}</h3>
      </div>
      <InputComponent
        name='title'
        placeholder='Título'
        label='Título'
        value={formData.title}
        onChange={handleChangeForm}
      />
      <InputFileComponent
        as='image'
        name='attachedFile'
        label='Imagen'
        value={formData.attachedFile as any}
        onChange={(e) => updateFormData({...formData, attachedFile: e.target.files})}
      />
      <div>
        <TextComponent
          type='text'
          style={{
            color: 'black',
            fontSize: '0.9rem',
            fontWeight: 600
          }}
        >
          Contenido
        </TextComponent>
        {!resetTiny ?
          <TinyEditorComponent
            data={formData.content}
            onChange={(content) => updateFormData({...formData, content: content})}
          />
        :null}
      </div>
      <ButtonComponent
        variant='primary'
        onClick={() => props.onHandleDescriptiveTrainingSubmit(formData)}
      >
        Guardar
      </ButtonComponent>
    </div>
  )
}

export default DescriptivetrainingformModuleLayout
